import type { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';
import type {
  SCRAPING_INTENT_MODE,
  SCRAPING_INTENT_SELECTOR_TYPE,
  ScrapingIntentListResponse,
} from '../types';

import { internalApiClient } from '@/shared/api-client/internal-api-client';
import { omitNullish } from '@/shared/utils/omit-nullish';

export type ListScrapingIntentsParams = {
  limit?: number;
  cursor?: string;
  type: SCRAPING_INTENT_SELECTOR_TYPE;
  platform?: SOURCE_PLATFORM_TYPE;
  keyword?: string;
  owner?: string;
  mode?: SCRAPING_INTENT_MODE;
};

export async function listScrapingIntents({
  type,
  limit,
  cursor,
  platform,
  keyword,
  owner,
}: ListScrapingIntentsParams): Promise<ScrapingIntentListResponse> {
  const response = await internalApiClient.get<ScrapingIntentListResponse>('scraping-intents', {
    searchParams: omitNullish({ type, limit, cursor, platform, keyword, owner }),
  });

  return response.json();
}
